<template>
  <b-row>
    <b-col md=5 class="float-left" offset="1">
      <b-row>
        <b-col cols="5" v-if="loan.processor">
          <div class="h5">Loan Account Coordinator</div>
          <email-button
            :email="loan.processor.email"
            :text="loan.processor.display_name"
            variant="outline-secondary"
            style-classes="mb-3"
          />
        </b-col>
        <b-col cols="5" v-if="loan.lma">
          <div class="h5">Loan Monitoring Associate</div>
          <email-button
            :email="loan.lma.email"
            :text="loan.lma.display_name"
            variant="outline-secondary"
            style-classes="mb-3"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col md="5" class="text-right">
      <dashboard-button style-classes="mb-3" />
      <entity-button
        v-if="entity"
        :entity="entity"
        :display-badge="false"
        :badgeText="entityNeededCount"
        style-classes="ml-2 mb-3 btn-anchor"
      />
      <documents-button
        style-classes="ml-2 mb-3"
        :display-badge="false"
        v-permission="permissionList"/>
      <deals-button style-classes="ml-2 mb-3" />
    </b-col>
  </b-row>
</template>


<script>
import DealsButton from '@/components/utils/buttons/navigation/DealsButton';
import DocumentsButton from '@/components/utils/buttons/navigation/DocumentsButton';
import DashboardButton from '@/components/utils/buttons/navigation/DashboardButton';
import EntityButton from '@/components/utils/buttons/navigation/EntityButton';
import EmailButton from '@/components/utils/buttons/misc/EmailButton';
import { MYDOCS_READ } from '@/libs/permissions_list';

export default {
  components: {
    EntityButton,
    DealsButton,
    DocumentsButton,
    DashboardButton,
    EmailButton,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
    entity: Object,
  },
  data() {
    return {
      permissionList: [MYDOCS_READ],
    };
  },
  computed: {
    entityNeededCount() {
      if (this.entity) {
        return this.entity.neededFiles;
      }
      return '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/LoanButtons.vue